const baseURL_API = process.env.REACT_APP_API_URL;
const baseURL_Client = process.env.REACT_APP_URL;

export {
    baseURL_API,
    baseURL_Client
}